export default "__VITE_ASSET__bea9d774__"